module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "navbar-view",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "toggleClick": _vm.toggleSideBar,
      "isActive": _vm.sidebar.opened
    }
  }), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('div', {
    staticClass: "user-name-view"
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.userName))])], 1), _vm._v(" "), _c('div', {
    staticClass: "avatar-view"
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": 1,
      "type": "primary"
    }
  }, [_c('el-avatar', {
    attrs: {
      "shape": "square",
      "size": 30,
      "src": _vm.handleImageUrl(_vm.userData.avatarUrl)
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.updateProfile
    }
  }, [_vm._v("\n          修改信息\n        ")])]), _vm._v(" "), _c('el-dropdown-item', [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("\n          退出登录\n        ")])])], 1), _vm._v(" "), _c('EditUserData', {
    ref: "editUserData"
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4cc7385b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cc7385b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = 1285
// module chunks = 1